import { render, staticRenderFns } from "./TeethExamMap.vue?vue&type=template&id=13ea2c34&"
import script from "./TeethExamMap.vue?vue&type=script&lang=ts&"
export * from "./TeethExamMap.vue?vue&type=script&lang=ts&"
import style0 from "./TeethExamMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports